<template>
  <div class="chart-cell">
    <dx-popup
      :container="container"
      title="Column Chooser"
      :width="350"
      :height="450"
      :resize-enabled="true"
      :shading="false"
      :show-close-button="true"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :visible="visible"
      @hiding="onHiding"
    >
      <dx-position at="center center" my="center center" :of="positionOf" />

      <dx-list
        :ref="listRefKey"
        :data-source="columnsList"
        displayExpr="caption"
        keyExpr="dataField"
        selection-mode="all"
        :show-selection-controls="true"
        :selected-items="selectedItems"
        :search-enabled="true"
        search-expr="caption"
        page-load-mode="scrollBottom"
      />

      <dx-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="applyButtonOptions"
      />

      <dx-toolbar-item
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="cancelButtonOptions"
      />
    </dx-popup>
  </div>
</template>
  <script>
  import DxPopup, { DxToolbarItem, DxPosition } from 'devextreme-vue/popup'
  import DxList from 'devextreme-vue/list'
  import { calculatedColumnsManagement } from '@/components/eventV2/columnManagementHelper.js'

  const listRefKey = 'custom-column-chooser'

  export default {
    components: {
      DxPopup,
      DxToolbarItem,
      DxPosition,
      DxList
    },

    props: {
      visible: {
        type: Boolean,
        required: true,
        default: () => false
      },
      container: {
        type: String,
        required: true,
        default: () => ''
      },
      button: {
        type: String,
        required: true,
        default: () => ''
      },
      columns: {
        type: Array,
        required: true,
        default: () => []
      },
      isAdmin: {
        type: Boolean,
        required: true,
        default: false
      }
    },

    data () {
      return {
        listRefKey,
        applyButtonOptions: {
          text: 'Apply',
          onClick: () => {
            const selectedItems = this.list.option('selectedItems')
            let changes = []
            changes = calculatedColumnsManagement(selectedItems, changes, this.columns)
            this.onApply(changes)
          }
        },
        cancelButtonOptions: {
          text: 'Cancel',
          onClick: () => {
            this.selectedItems = this.columns
              .filter((column) => column.visible)
              .map((column) => ({
                dataField: column.dataField,
                caption: this.$t(column.caption)
              }))
            this.onHiding()
          }
        },
        positionOf: `${this.container} ${this.button}`,
        columnsList: this.columns
          .filter((column) => (!column.adminOnly || column.adminOnly === this.isAdmin) && (column.internVisible === undefined))
          .map((column) => ({
            dataField: column.dataField,
            caption: this.$t(column.caption),
            disabled: column.dataField === 'cRMAddress.field_001',
            isProfile: column.isProfile
          })),
        selectedItems: this.columns
          .filter((column) => column.visible)
          .map((column) => ({
            dataField: column.dataField,
            caption: this.$t(column.caption)
          }))
      }
    },
    methods: {
      onHiding () {
        this.$emit('call-on-hiding')
      },
      onApply (changes) {
        this.$emit('call-apply', changes)
      }
    },

    computed: {
      list: function () {
        return this.$refs[listRefKey].instance
      }
    }
  }
  </script>
